export const leadGenErrorMessage = "Thank you for choosing Berjaya Sompo Insurance. We’re unable to process your renewal online at the moment. Please fill in the form below, and our team will get in touch with you."

export const generalErrorMessage = "We are unable to proceed with your insurance purchase as it does not meet our underwriting guidelines. Thank you for considering Berjaya Sompo Insurance."

// export const generalErrorMessage = `Sorry, we are unable to proceed with your request online.
//   Please contact our Customer Service at 1 800 889 933 or +603 2170 7300, operating hours 8:30am - 5.00pm (Monday to Friday) excluding public holidays. 
//   Alternatively, you may email your car details (car plate and NRIC) to banca.support@bsompo.com.my for further assistance.`


export default [
  {
    apiError: "general",
    message: generalErrorMessage
  },
  {
    apiError: "Referred",
    message: leadGenErrorMessage
  },
  {
    apiError: "Decline",
    message: leadGenErrorMessage
  },
  // {
  //   apiError: "ISM Connectivity Error",
  //   message: generalErrorMessage
  // },
  // {
  //   apiError: "[INVALID PERMANENT POST CODE]",
  //   message: "Invalid Post Code!"
  // },
  // {
  //   apiError: "UW Policy holder Age Referred",
  //   message: generalErrorMessage
  // },
  {
    apiError: "POLICY LAPSED DAYS SHOULD NOT BE MORE THAN 14 DAYS",
    message: generalErrorMessage
  },
  // {
  //   // TP to comprehensive
  //   apiError: "1 - Scope of Cover changed from Third Party to Comprehensive Referred $$UW Sum Insured Referred",
  //   message: generalErrorMessage
  // },
  // {
  //   apiError: "UW Sum Insured Referred",
  //   message: generalErrorMessage
  // },
  // {
  //   // a case of high perf vehicle got this error
  //   apiError: "MAKE MODEL MISSING",
  //   message: generalErrorMessage
  // },
  {
    apiError: "sessionExpired",
    message: "Your session has expired. Please retry from beginning"
  },
  // {
  //     apiError: "InvalidOTP",
  //     message: "Your OTP is invalid, please try again!"
  // },
  // {
  //     apiError: "missingDetail",
  //     message: "Please ensure your personal details are complete"
  // },
  {
    apiError: "Error in IDNo1 or IDNo2 or ID not matches",
    message: "An error occurred while retrieving your information. Please ensure you have filled in your NRIC/Passport Number and Vehicle Registration Number correctly."
  },
  {
    apiError: "Previous Policy Lapsed",
    message: "We are unable to renew your car insurance online due to your insurance policy has lapsed for more than 14 days.",
  },
  {
    apiError: "POLICY SHOULD BE LESS THAN 60 DAYS",
    message: "We are unable to proceed with your purchase as your insurance policy's expiry date is more than 2 months away. Please try again at a later date."
  },
  {
    apiError: "UW Make & Model Referred",
    message: "We are unable to renew your car insurance online because your vehicle model is not on our coverage list. Thank you for taking the time to consider Berjaya Sompo Insurance."
  },
  {
    apiError: "Pricing Field Error",
    message: "There was an error in retrieving your information."
  },
  // {
  //     apiError: "MULTIPLE NVIC RECEIVED",
  //     message: "There was an error in retrieving your information."
  // },
  {
    apiError: "Number of Claim at Fault 2 Referred",
    message: "We are unable to process your car insurance online as your personal ID and/or vehicle(s) has 2 or more claims at fault in the past 3 years. Thank you for taking the time to consider Berjaya Sompo Insurance."
  },
  // {
  //     apiError: "Wrong vehicle class",
  //     message: "Motorcycle"
  // },
  // {
  //     apiError: "SUM INSURED IS 0",
  //     message: "There was an error in retrieving your information."
  // },
  // {
  //     apiError: "renewalNotFound",
  //     message: "We are unable to find record of your previous year policy with us. To proceed, please fill in your details"
  // }
  {
    apiError: 'REQUEST LIMIT EXCEEDED',
    message: 'REQUEST LIMIT EXCEEDED'
  },
]